import styles from './MemberTable.module.scss';
import { ReactComponent as UserIcon } from 'assets/svg/user-profile.svg';
import Loading from 'components/Loading';
import { useTeamContext } from 'contexts/group-practice-context/TeamContext';
import MoreActionsDropdown from '../../utils/MoreActionsDropdown';
import removeMemberFromTeam from 'services/team/removeMember';
import { useState } from 'react';
import ConfirmDeleteModal from './ConfirmDelete';
import { MemberType } from '../../types/types';
import { getErrorDetail } from 'components/utility/utils';

const TeamMembersTable = ({ teamMembers, setCurrentPage, loading, setError, setLoading, setSuccessMsg }) => {
  // const { setCurrentMember, currentTeam } = useTeamContext();
  const { currentTeam , setReload} = useTeamContext();
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [member, setMember] = useState<MemberType | null>(null)

  const handleDeleteMember = async () => {
    if (!currentTeam || !member) return;
    setLoading(true)
    try {
      await removeMemberFromTeam(Number(currentTeam.id), member.orchid_user_id);
      setShowConfirmModal(false);
      setMember(null);
      setSuccessMsg("Member removed Successfully");
      setReload(prev => prev + 1);
    } catch (err) {
      setError(getErrorDetail(err))
    }finally{
setLoading(false)
    }
    
  };
  const handleModalClose = () =>{
    setMember(null);
    setShowConfirmModal(false)
  }

  const getDropdownActions = () => {
    return [
      // {
      //   label: 'Edit',
      //   actionLabel: 'EDIT_ACTION',
      //   onClick: member => {
      //     setCurrentMember(member);
      //     setCurrentPage('member-details');
      //   },
      // },
      {
        label: 'Delete',
        actionLabel: 'DELETE_ACTION',
        onClick: (member) => {
          setShowConfirmModal(true);
          setMember(member)
        },
        className: 'text-danger',
      },
    ];
  };

  const StatusTag = ({ status }) => (
    <span
      className={
        status.toLowerCase() === 'active'
          ? styles['member_charts__status-tag--active']
          : styles['member_charts__status-tag--inactive']
      }
    >
      {status.charAt(0).toUpperCase() + status.slice(1).toLowerCase()}
    </span>
  );

  // const AuthTag = ({ authStatus }) => (
  //   <span
  //     className={
  //       authStatus
  //         ? styles['member_charts__status-tag--active']
  //         : styles['member_charts__status-tag--inactive']
  //     }
  //   >
  //     {authStatus ? 'Active' : 'Inactive'}
  //   </span>
  // );

  const RoleTag = ({ role }) => {
    if (role === 'PRACTICE_SCHEDULER') {
      return <span>Practice Scheduler</span>;
    }
    const formattedRole =
      role.charAt(0).toUpperCase() + role.slice(1).toLowerCase();

    return <span>{formattedRole}</span>;
  };

  const OwnerTag = () => {
    return <span className={styles['member_charts__owner-tag']}>Owner</span>;
  };

  if (loading) {
    return <Loading />;
  }

  if (!loading && (!teamMembers || teamMembers.length === 0)) {
    return (
      <div className='w-100 h-100 d-flex justify-content-center align-items-center'>
        <h3>No members found</h3>
      </div>
    );
  }

  return (
    <>
      {showConfirmModal && (
        <ConfirmDeleteModal
          onConfirmDelete={handleDeleteMember}
          show={showConfirmModal}
          onClose={handleModalClose}
          member={member}
        />
      )}
      {teamMembers.length > 0 && (
        <div className={styles['member_charts__table-container']}>
          <table className={styles['member_charts__table']}>
            <thead>
              <tr className={styles['member_charts__table-header-row']}>
                <th className={styles['member_charts__table-col-name--header']}>
                  <span className={styles['member_charts__client-name']}>
                    <div className='d-flex align-items-center'>
                      {/* <label htmlFor='members-select-all'>
                        <input
                          type='checkbox'
                          className={styles['member_charts__header-input-tag']}
                          name={`members-select-all`}
                          title='Select all members'
                          disabled
                        />
                      </label> */}
                      Name
                    </div>
                  </span>
                </th>
                <th className={styles['member_charts__table-col-contact']}>
                  Contact Info
                </th>
                <th className={styles['member_charts__table-col-role']}>
                  {/* TODO - MAKE IT A DROPDOWN */}
                  Role
                </th>
                {/* <th className={styles['member_charts__table-col-status']}>
                  Consent
                </th> */}
                {/* <th className={styles['member_charts__table-col-dob']}>
                  2-Step Authentication
                </th> */}
                <th className={styles['member_charts__table-col-clinician']}>
                  Status
                </th>
                <th
                  className={styles['member_charts__table-col-action--header']}
                ></th>
              </tr>
            </thead>
          </table>
          <table className={styles['member_charts__table']}>
            <tbody>
              {teamMembers.map((member, i) => (
                <tr key={`team-member-${member.id}-${i}`}>
                  <td className={styles['member_charts__table-col-name']}>
                    <div className='d-flex align-items-start'>
                      {/* <label htmlFor={`member-select-${member.id}`}>
                        <input
                          title={`Select ${member.name}`}
                          type='checkbox'
                          className={`${styles['member_charts__input-tag']} mr-2 mt-1`}
                          disabled
                        />
                      </label> */}
                      <div className='d-flex align-items-center'>
                        <span
                          className={styles['member_charts__client-avatar']}
                        >
                          {/* TODO-ADD USER'S PROFILE IMAGE HERE */}
                          <UserIcon />
                        </span>
                        <span>
                          {member.first_name} {member.last_name}
                        </span>
                        {member.role.toLowerCase() === 'owner' && <OwnerTag />}
                      </div>
                    </div>
                  </td>
                  <td className={styles['member_charts__table-col-contact']}>
                    <div>
                      <div className='d-flex align-items-center position-relative'>
                        <span className={styles['member_charts__contact-text']}>
                          {member.contact_email}
                        </span>
                      </div>
                      <div className='d-flex align-items-center position-relative'>
                        {member?.contact_no}
                      </div>
                    </div>
                  </td>
                  <td className={styles['member_charts__table-col-role']}>
                    <RoleTag role={member.role} />
                  </td>
                  {/* <td className={styles['member_charts__table-col-status']}>
                    <span
                      className={
                        member?.consent
                          ? styles['member_charts__consent-text']
                          : ''
                      }
                    >
                      {member?.consent ? 'Accepted' : 'Not Accepted'}
                    </span>
                  </td> */}
                  {/* <td className={styles['member_charts__table-col-dob']}>
                    <span>
                      <AuthTag authStatus={member?.two_factor_auth_enabled} />
                    </span>
                  </td> */}
                  <td className={styles['member_charts__table-col-clinician']}>
                    <StatusTag status={member?.status} />
                  </td>
                  <td className={styles['member_charts__table-col-action']}>
                    <div className='d-flex align-items-center'>
                      <MoreActionsDropdown
                        member={member}
                        actions={getDropdownActions()}
                      />
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </>
  );
};

export default TeamMembersTable;
